import React, { Fragment, FunctionComponent } from 'react';
import styled from 'styled-components';
import { Field } from 'react-final-form';
import {
  Box,
  Label,
  InputField,
  RadioButtonGroup,
  RadioButtonField,
  SelectField,
} from 'mdlkit';
import { StyledFlex } from '../../shared/Styles';
import { StyledText } from './InsuranceForm';
import Gender from '../Gender';
import { useTheme } from '../../../core/hooks';
import { required } from '../../../utils/shared/validations';
import { MONTHS } from '../../../constants/months';
import { normalizeNumbersOnly } from '../../../utils/register/normalize';
import { DOBGroup } from '../PatientForm';

const RELATIONSHIP = {
  spouse: '01',
  child: '19',
  other: '34',
};

const DOBWrapper = styled(Box)`
  margin-top: ${({ theme }) => theme.space.xs + theme.space.sm}px;
`;

const StyledLabel = styled(Label)`
  align-self: self-start;
  padding-top: ${({ theme }) => theme.space.xs + theme.space.sm}px;
`;

const PrimaryForm: FunctionComponent = () => {
  const theme = useTheme();

  return (
    <Fragment>
      <StyledText>Enter Primary Policyholder&apos;s information</StyledText>
      <StyledFlex pt="sm">
        <Box>
          <Field
            id="primaryFirstName"
            label="Primary First Name"
            name="primaryFirstName"
            component={InputField}
            validate={required}
            autoCorrect="off"
            spellCheck={false}
          />
        </Box>
        <Box>
          <Field
            id="primaryLastName"
            label="Primary Last Name"
            name="primaryLastName"
            component={InputField}
            validate={required}
            autoCorrect="off"
            spellCheck={false}
          />
        </Box>
      </StyledFlex>

      <DOBWrapper as="fieldset">
        <Label as="legend">Primary Date of Birth</Label>
        <DOBGroup pt="xs">
          <Box>
            <Field
              id="primaryDobMonth"
              label="Month"
              name="primaryDobMonth"
              validate={required}
              component={SelectField}
              blank
              options={MONTHS}
            />
          </Box>
          <Box>
            <Field
              id="primaryDobDay"
              label="Day"
              name="primaryDobDay"
              validate={required}
              component={InputField}
              maxLength={2}
              parse={normalizeNumbersOnly}
            />
          </Box>
          <Box>
            <Field
              id="primaryDobYear"
              label="Year"
              name="primaryDobYear"
              validate={required}
              component={InputField}
              maxLength={4}
              parse={normalizeNumbersOnly}
            />
          </Box>
        </DOBGroup>
      </DOBWrapper>

      <Field
        pt={theme.space.xs + theme.space.sm}
        id="primaryMemberId"
        label="Primary Insurance Member ID"
        name="primaryMemberId"
        validate={required}
        component={InputField}
        autoCorrect="off"
        spellCheck={false}
      />

      <StyledLabel htmlFor="gender">
        Primary Policyholder&apos;s Gender
      </StyledLabel>
      <Gender pt="sm" isPrimary />

      <StyledLabel htmlFor="relationship">
        Your relationship to Policyholder
      </StyledLabel>
      <RadioButtonGroup pt="sm">
        <Field
          id="spouse"
          type="radio"
          label="Spouse"
          name="relationship"
          component={RadioButtonField}
          value={RELATIONSHIP.spouse}
        />
        <Field
          id="child"
          type="radio"
          label="Child"
          name="relationship"
          component={RadioButtonField}
          value={RELATIONSHIP.child}
        />
        <Field
          id="otherAdult"
          type="radio"
          label="Other Adult"
          name="relationship"
          component={RadioButtonField}
          value={RELATIONSHIP.other}
        />
      </RadioButtonGroup>
    </Fragment>
  );
};

export default PrimaryForm;
